import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Button } from './Button';
import { Seal } from '../brand/Seal';
interface CtaBandProps {
  title?: string;
  intro?: string;
}
export function CtaBand({
  title = 'More choice is better health for all.',
  intro = 'Start with the intake. Nothing is charged until a clinician has reviewed your labs and you have approved the protocol.'
}: CtaBandProps) {
  return <section className="border-t border-ink/10 bg-cream-deep text-ink" data-id="element-250" data-mp="v3tuqodwnaju">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-251" data-mp="r0nq1l6fxrfh">
        <div className="grid items-center gap-12 lg:grid-cols-[1.3fr_auto] lg:gap-20" data-id="element-252" data-mp="r3jm13yqa61a">
          <div data-id="element-253" data-mp="m46rdx1m7uo5">
            <h2 className="max-w-2xl font-serif text-4xl leading-[1.06] md:text-[3.5rem]" data-id="element-254" data-mp="h2zifunqkpfw">
              {title}
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-ink-soft" data-id="element-255" data-mp="2ggdenu7sa1wt">{intro}</p>
            <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-256" data-mp="2bgiipc95im4w">
              <Button to="/get-started" data-id="element-257" data-mp="2p63c4ppqpcc6">
                Start your intake
                <ArrowRightIcon className="h-4 w-4" data-id="element-258" data-mp="2p4s94s44c8m4" />
              </Button>
              <Button to="/pricing" variant="secondary" data-id="element-259" data-mp="2t8gfj7h0ky5s">
                See pricing
              </Button>
            </div>
          </div>
          <Seal className="hidden h-40 w-40 text-brick/60 lg:block" data-id="element-260" data-mp="2fa8qdlq7z156" />
        </div>
      </div>
    </section>;
}